export enum EndpointType {
  ON_CORNER = 0,
  ALONG_EDGE = 1,
  ON_PANEL = 2,
}
